import service from '../services/index.service';

export default {
  namespaced: true,
  state: {
    contratos: [],
    estadosEntregables: [],
    estadoContratoStyles: {},
    entregablesPorConsultoria: {},
    // Mock data para detalle entregable
    detalleEntregable: null,
    consultoresDesignados: [],
    nominas: [],
    nominasMeta: {},
    entregableNomina: null,
    consultor: null,
    historialPagos: null,
    // fotoConsultor: null,
    // Filtros
    buscar: '',
    estadoSeleccionado: null,
    // Modal entregables a vencer
    entregablesAVencer: { items: [], total: 0, mensaje: '', perfilUsuario: '' },
    showModalEntregablesVencer: false,
  },

  getters: {
    getContratos: state => state.contratos,
    getEstadosEntregables: state => state.estadosEntregables,
    getEstadoContratoStyles: state => state.estadoContratoStyles,
    getEntregablesPorConsultoria: state => state.entregablesPorConsultoria,
    getDetalleEntregable: state => state.detalleEntregable,
    getConsultoresDesignados: state => state.consultoresDesignados,
    getNominas: state => state.nominas,
    getNominasMeta: state => state.nominasMeta,
    getEntregableNomina: state => state.entregableNomina,
    getConsultor: state => state.consultor,
    getHistorialPagos: state => state.historialPagos,
    // getFotoConsultor: state => state.fotoConsultor,
    getEntregablesAVencer: state => state.entregablesAVencer,
    getShowModalEntregablesVencer: state => state.showModalEntregablesVencer,
  },

  mutations: {
    setContratos(state, items) {
      state.contratos = items;
    },
    setEstadosEntregables(state, items) {
      state.estadosEntregables = items;
    },
    setEstadoContratoStyles(state, styles) {
      state.estadoContratoStyles = styles;
    },
    setEntregablesConsultoria(state, data) {
      state.entregablesPorConsultoria = data;
    },
    setDetalleEntregable(state, data) {
      state.detalleEntregable = data;
    },
    setConsultoresDesignados(state, items) {
      state.consultoresDesignados = items;
    },
    setNominas(state, items) {
      state.nominas = items;
    },
    setNominasMeta(state, meta) {
      state.nominasMeta = meta;
    },
    setEntregableNomina(state, entregable) {
      state.entregableNomina = entregable;
    },
    setConsultor(state, data) {
      state.consultor = data;
    },
    setHistorialPagos(state, data) {
      state.historialPagos = data;
    },
    // setFotoConsultor(state, url) {
    //   state.fotoConsultor = url;
    // },
    setBuscar(state, value) {
      state.buscar = value;
    },
    setEstadoSeleccionado(state, estado) {
      state.estadoSeleccionado = estado;
    },
    limpiarFiltros(state) {
      state.buscar = '';
      state.estadoSeleccionado = null;
    },
    setEntregablesAVencer(state, items) {
      state.entregablesAVencer = items;
    },
    setShowModalEntregablesVencer(state, value) {
      state.showModalEntregablesVencer = value;
    },
  },

  actions: {
    async fetchEstadosEntregables({ commit }) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.fetchEstadosEntregables();
        const estados = response?.data?.data || [];
        commit('setEstadosEntregables', estados);
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    setEstadoSeleccionado({ commit }, estado) {
      commit('setEstadoSeleccionado', estado);
    },

    actualizarBuscar({ commit }, value) {
      commit('setBuscar', value);
    },

    limpiarFiltros({ commit }) {
      commit('limpiarFiltros');
    },

    // cargar entregables
    async fetchEntregables(
      { commit, state },
      { contratoId, params = {} } = {}
    ) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const queryParams = {
          search: state.buscar,
          estado: state.estadoSeleccionado,
          ...params,
        };
        const response = await service.fetchEntregables(
          contratoId,
          queryParams
        );

        const items = response?.data?.data?.entregables || [];

        commit('setEntregablesConsultoria', items);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    // guardar entregable
    async guardarEntregable({ commit }, payload) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const entregables = await service.guardarEntregable(payload);
        return;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    // editar entregable
    async actualizarEntregable({ commit }, { payload, consultoriaId }) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        await service.actualizarEntregable(payload);
        return;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async eliminarEntregable({ commit }, payload) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        if (!payload) return;
        await service.eliminarEntregable(payload);
        return;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async descargarPlantilla({ commit }, payload) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.descargarPlantilla();
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },
    async importarEntregables({ commit }, formData) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        // Llamada al servicio con el formData correcto
        const response = await service.importarEntregables(formData);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },
    async fetchNominasNoAsignado({ commit }, { id, params = {} } = {}) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.fetchNominasNoAsignado(id, params);
        const data = response?.data?.data || {};

        commit('setEntregableNomina', data.entregable || null);
        commit('setNominas', data.empleados?.items || []);
        commit('setNominasMeta', data.empleados?.meta || {});
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    // Vista de detalle entregable
    async fetchDetalleEntregable({ commit }, { id, params = {} }) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.fetchDetalleEntregable(id, params);
        const data = response?.data?.data || {};

        // Se mapean los datos al estado según la estructura del PHP recibido
        commit('setDetalleEntregable', data.entregable || null);

        // Si el detalle incluye los consultores (empleados), los guardamos también
        if (data.empleados && data.empleados.items) {
          commit('setConsultoresDesignados', data.empleados.items);
        }

        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async fetchConsultoresDesignados({ commit }, id) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.fetchConsultoresDesignados(id);
        const data = response?.data?.data || {};
        const items = data.items || data.empleados?.items || [];
        commit('setConsultoresDesignados', items);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async fetchConsultor({ commit }, id) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.fetchConsultor(id);
        const data = response?.data?.data || null;
        commit('setConsultor', data);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async fetchHistorialPagos({ commit }, nominaId) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.fetchHistorialPagos(nominaId);
        const data = response?.data?.data || {};

        const parseMonto = str =>
          parseFloat((str || '0').replace(/[$,]/g, '')) || 0;

        const historial = {
          nombreCompleto: data.empleado?.nombre || '',
          codigoConsultor: data.empleado?.consultora || null,
          totalPagado: parseMonto(data.resumen?.total_pagado),
          entregablesCompletados: data.resumen?.entregables_completados || 0,
          pagos: (data.historial || []).map(p => ({
            entregable: p.entregable,
            fechaPago: p.fecha_pago,
            cifradoAsignado: p.codigo_cifrado_establecimiento || p.codigo_cifrado || '-',
            monto: parseMonto(p.monto),
          })),
        };

        commit('setHistorialPagos', historial);
        return historial;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    // abrirDetalleConsultor({ commit, dispatch }, consultor) {
    //   const id = consultor?.usuario?.id;
    //   if (id) {
    //     dispatch('fetchFotoConsultor', id);
    //   } else {
    //     commit('setFotoConsultor', null);
    //   }
    // },

    // async fetchFotoConsultor({ commit }, id) {
    //   try {
    //     const response = await service.fetchFotoConsultor(id);
    //     const configuracion = response?.data;
    //     const url = `data:image/${configuracion?.extension};base64,${configuracion?.file}`;
    //     commit('setFotoConsultor', url);
    //   } catch {
    //     commit('setFotoConsultor', null);
    //   }
    // },

    async asignarEmpleadosEntregable(_, { entregableId, asignaciones }) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.asignarEmpleadosEntregable(entregableId, asignaciones);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async cerrarEntregables(_, consultoria_id) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const response = await service.cerrarEntregables(consultoria_id);
        return response;
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async verificarEntregablesAVencer({ commit }) {
      if (sessionStorage.getItem('modalEntregablesVencerMostrado')) return;
      try {
        const response = await service.fetchEntregablesAVencer();
        const data = response?.data?.data || {};
        const items = data.entregables || [];
        const mensaje = response?.data?.message || '';
        commit('setEntregablesAVencer', { items, total: data.total || 0, mensaje, perfilUsuario: data.perfilUsuario || '' });
        if (items.length > 0) {
          commit('setShowModalEntregablesVencer', true);
          sessionStorage.setItem('modalEntregablesVencerMostrado', '1');
        }
      } catch {
        // silencioso: no interrumpir el flujo de login
      }
    },
  },
};
